module.exports = __webpack_public_path__ + "img/Journalisma3.b350af62.png";